import { render, staticRenderFns } from "./MobileEventRecords.vue?vue&type=template&id=5ae75cdf&scoped=true"
import script from "./MobileEventRecords.vue?vue&type=script&lang=ts"
export * from "./MobileEventRecords.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae75cdf",
  null
  
)

export default component.exports